import { createSelector } from "reselect";

import type { Vehicle } from "@busbud/int-schemas/udm/properties/vehicle";

import { getCartV2TripItem } from "@app/modules/checkout/utils/cart-v2";
import { getCart } from "@app/modules/results/selectors/state-accessors";

type SegmentsVehicleLayout = Record<string, Vehicle["layout"]>;
const EMPTY_OBJ: SegmentsVehicleLayout = {};

export const getAsyncCartSegmentsVehicleLayout = createSelector(
  getCart,
  cart_state => {
    const cart = cart_state?.cart;
    if (!cart) {
      return EMPTY_OBJ;
    }

    const cart_trip_item = getCartV2TripItem(cart.items);

    if (!cart_trip_item) {
      return EMPTY_OBJ;
    }

    return cart_trip_item.segments.reduce(
      (acc, segment) => {
        if (segment.vehicle && segment.vehicle.layout) {
          acc[segment.id] = segment.vehicle.layout;
        }

        return acc;
      },
      {} as Record<string, Vehicle["layout"]>
    );
  }
);
